import { createBaseThemeVariation } from './base';
export const CpcOrchardsTheme = createBaseThemeVariation({
    name: 'cpc-orchards',
    brandColor: 'hsla(150, 50%, 40%, 1)',
    primaryColors: {
        p50: 'hsla(150, 50%, 98%, 1)',
        p75: 'hsla(150, 50%, 97%, 1)',
        p100: 'hsla(150, 50%, 96%, 1)',
        p200: 'hsla(150, 50%, 90%, 1)',
        p300: 'hsla(150, 50%, 70%, 1)',
        p400: 'hsla(150, 50%, 40%, 1)',
        p500: 'hsla(150, 50%, 10%, 1)',
    },
});
